// extracted by mini-css-extract-plugin
export default {"header":"TabletHeader_header__+0IVS"};